<div [hidden]="impersonatedUser == undefined" style="background-color: var(--green-800); color:#ffffff; padding: 12px 24px; width: 100%; box-sizing: border-box;">
	<div style="display: flex; width: 100%;">
    <div style="display:flex; flex:1; justify-content: center; gap:10px;  align-items: center">
      <div style="text-align: center;">Currently impersonating 
        <span style="font-weight: 500;">{{ impersonatedUser?.firstName }} {{ impersonatedUser?.lastName }}
          ({{getUserRoleToDisplay()}})
        </span>
      </div>
    </div>
    <div style="display:flex; gap: 10px; padding-right:25px; align-items: center">
      <div>  
        <input type="button" value="Stop Impersonating" class="secondary" (click)="btnEndImpersonation_click()" />
      </div>
    </div>
	</div>
</div>
